var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"SuccessfullyReceived"}},[_c('div',{staticClass:"successMain"},[_c('div',{staticClass:"tips3"},[_c('p',[_vm._v("你的账号已创建")]),_c('p',[_vm._v("请保持电话畅通，将有工作人员联系你")])]),_c('div',{staticClass:"successBot"},[_c('img',{attrs:{"src":require("../../assets/images/logo.png"),"alt":""}})])])])
}]

export { render, staticRenderFns }